export default __webpack_public_path__ + "static/media/160.581e21b5.png";